import { Difficulty } from "@all-for-one/shared-types"
import { resolveApiHostname } from 'util/api-hostname'

type UpdateStudentDifficultyTrigger = (args: {
    classId: string
    studentId: string
    difficulty: Difficulty
}) => { unwrap: () => Promise<any> }

export const handleStudentDifficultyChange = async (
    updateStudentDifficulty: UpdateStudentDifficultyTrigger,
    classId: string,
    studentId: string,
    newDifficulty: Difficulty
) => {
    try {
        await updateStudentDifficulty({
            classId,
            studentId,
            difficulty: newDifficulty,
        }).unwrap()
        console.log('Difficulty updated successfully')
    } catch (error) {
        console.error('Failed to update difficulty:', error)
    }
}

export const getWsBaseUrl = (): string => {
    const isHttps = window.location.protocol === 'https:'
    const wsProto = isHttps ? 'wss' : 'ws'
    return `${wsProto}://${resolveApiHostname()}/ws`
}